import { render } from "./LineColumn.vue?vue&type=template&id=167149fc&scoped=true"
import script from "./LineColumn.vue?vue&type=script&lang=js"
export * from "./LineColumn.vue?vue&type=script&lang=js"

import "./LineColumn.vue?vue&type=style&index=0&id=167149fc&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167149fc"]])

export default __exports__